import { style, animate, transition } from "@angular/animations";

export const openingClosing = [
	transition(":enter", [
		style({ opacity: 0, transform: "translateY(10%) scale(0.9)" }),
		animate("250ms ease-in-out", style({ opacity: 1, transform: "translateY(0) scale(1)" }))
	]),
	transition(":leave", [
		animate(
			"250ms ease-in-out",
			style({
				opacity: 0,
				transform: "translateY(25%) scale(0.9)"
			})
		)
	])
];

export const fadeIn = [transition(":enter", [style({ opacity: 0 }), animate("500ms", style({ opacity: 1 }))])];
